import React from "react";
import Classes from "./Spinner.module.scss";

const Spinner = () => {
	return <div className={Classes.loaderContainer}><div className={Classes.loader}>Loading...</div></div>;
};

export default Spinner;
